import {Button} from "@progress/kendo-react-buttons"
import {Field, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {Input} from "@progress/kendo-react-inputs"
import {MDBBreadcrumb, MDBBreadcrumbItem, MDBCol, MDBRow} from "mdbreact"
import AddVehicle from "../../components/Vehicles/AddVehicle"
import VehicleGrid from "../../components/Vehicles/VehicleGrid"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import {getVehicles, setRefreshDVSAVisibleButton, setVehicleSearchText, toggleModalPopup} from "./vehicleSlice"

const Vehicles = () => {
    const vehicleSearch = useAppSelector((state: RootState) => state.containers.vehicles.vehicleSearchText)
    const showDialog = useAppSelector((state: RootState) => state.containers.vehicles.showDialog)

    // const [toggleDialog, setDialog] = useState(false)
    const showAddDialog = () => dispatch(toggleModalPopup(true))
    const hideAddDialog = () => dispatch(toggleModalPopup(false))
    const dispatch = useAppDispatch()
    const changeHandler = (e: any) => {
        if (e.value.length === 0) dispatch(setRefreshDVSAVisibleButton(false))
        dispatch(setVehicleSearchText(e.value))
    }
    const isRefreshDVSAButtonVisible = useAppSelector(
        (state: RootState) => state.containers.vehicles.isRefreshDVSAButtonVisible,
    )

    const refreshMOTHistory = (VehicleRegNo: string) => {
        dispatch(setRefreshDVSAVisibleButton(true))
        dispatch(getVehicles(VehicleRegNo, true))
    }

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Settings </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Vehicles</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <Form
                onSubmit={() =>
                    vehicleSearch.trim().length >= 3 && dispatch(getVehicles(vehicleSearch.replaceAll(" ", ""), false))
                }
                initialValues={{vehicleSearch}}
                render={(formRenderProps: FormRenderProps) => (
                    <div className="mb-2">
                        <MDBRow className="align-items-end">
                            <MDBCol md="2" sm="3">
                                <FormElement style={{maxWidth: 400}}>
                                    <fieldset className={"k-form-fieldset"}>
                                        <Field
                                            onChange={changeHandler}
                                            name={"vehicleSearch"}
                                            component={Input}
                                            label={"Search Registration"}
                                        />
                                    </fieldset>
                                </FormElement>
                            </MDBCol>
                            <MDBCol>
                                <div className="k-form-buttons mt-auto">
                                    <Button
                                        type="submit"
                                        fillMode="flat"
                                        themeColor={"primary"}
                                        disabled={vehicleSearch.length === 0}
                                        onClick={formRenderProps.onSubmit}
                                    >
                                        GO
                                    </Button>
                                    <Button
                                        type="submit"
                                        fillMode="flat"
                                        themeColor={"primary"}
                                        hidden={!isRefreshDVSAButtonVisible}
                                        onClick={() =>
                                            vehicleSearch.trim().length >= 2 &&
                                            refreshMOTHistory(vehicleSearch.replaceAll(" ", ""))
                                        }
                                    >
                                        Refresh from DVSA
                                    </Button>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </div>
                )}
            />
            <div>
                <VehicleGrid showAddDialog={showAddDialog} />
                <AddVehicle toggleDialog={showDialog} hideAddDialog={hideAddDialog} />
            </div>
        </>
    )
}

export default Vehicles
